import * as React from "react";
import { useAccountKeepAlive } from "../Components/useAccountKeepAlive";
import { Permission, User } from "../misc/api/apiTypes";
import { WebPortalClient, Role } from "webportalclient";
import { useAuth } from "react-oidc-context";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";
import { GetUserContext } from "../misc/api/SerenityUsers";

interface SecurityContextState {
    currentUser: User;
    currentUserPermissions: Permission[];
    roles: Role[];
    context: UserContext;
}

export const SecurityContext = React.createContext<SecurityContextState | undefined>(undefined);

interface SecurityContextProviderProps {
    user: User;
    children: React.ReactNode;
}

export interface UserContext {
    ProfileEditUrl: string;
    PasswordResetUrl: string;
}


export const SecurityContextProvider = ({ user, children }: SecurityContextProviderProps) => {
    const [permissions, setPermissions] = React.useState<Permission[]>([]);
    const [roles, setRoles] = React.useState<Role[]>([]);
    const [userContext, setUserContext] = React.useState<UserContext | undefined>(undefined);
    const client = useWebPortalApiClient();
    const legacyClient = useWebPortalLegacyClient();
    const { settings } = useAuth();
    useAccountKeepAlive();

    React.useEffect(() => {
        const getData = async () => {
            const userContext = await GetUserContext(settings.metadataUrl);
            setUserContext(userContext);

            const permissionResult = await legacyClient.getPermissions({});
            setPermissions(permissionResult.Data);

            const roleResult = await client.client.getRoles();
            setRoles(roleResult.value);
        }

        getData();
    }, [user]);

    return (
        <SecurityContext.Provider value={{ currentUser: user, currentUserPermissions: permissions, roles: roles, context: userContext }}>
            {children}
        </SecurityContext.Provider>
    );
}

export const useSecurityContext = () => {
    const context = React.useContext(SecurityContext);
    if (context === undefined) {
        throw new Error('useSecurityContext must be used within a SecurityContext Provider')
    }

    return context;
}
